module.exports = __webpack_public_path__ + "static/media/intro.b67191a.webm";


//////////////////
// WEBPACK FOOTER
// ./static/video/intro.webm
// module id = Z71U
// module chunks = 1